import { render, staticRenderFns } from "./Disassignments.vue?vue&type=template&id=2ae1ed8e&scoped=true&"
import script from "./Disassignments.vue?vue&type=script&lang=js&"
export * from "./Disassignments.vue?vue&type=script&lang=js&"
import style0 from "./Disassignments.vue?vue&type=style&index=0&id=2ae1ed8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1ed8e",
  null
  
)

export default component.exports